/* =====================================================================
   Steeply blog blocks: optional script
   Add this file to your Shopify theme as assets/steeply.js next to
   steeply.css (see README). It turns product sliders into a carousel:
   dots and arrows move a group of cards at a time, dragging with a
   mouse or finger can stop on any single card, and it wraps around at
   both ends. It also gives image galleries with the lightbox option a
   full-size viewer when a picture is clicked.
   Without it the slider is still a plain row that scrolls and snaps and
   gallery pictures stay on the page; nothing else depends on this file.
   ===================================================================== */
(function () {
  'use strict';

  var DURATION = 450; // ms, keep in step with the transition in steeply.css
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function enhance(track) {
    if (track.closest('.sp-slider')) return; // already done
    var cards = Array.prototype.slice.call(track.children);
    var n = cards.length;
    if (n < 2) return;
    // Cards slide into view sideways, which lazy loading handles late: load the handful of images now.
    var lazy = track.querySelectorAll('img[loading="lazy"]');
    for (var li = 0; li < lazy.length; li++) lazy[li].loading = 'eager';

    var wrap = el('div', 'sp-slider sp-slider--js');
    var viewport = el('div', 'sp-slider__viewport');
    track.parentNode.insertBefore(wrap, track);
    wrap.appendChild(viewport);
    viewport.appendChild(track);
    var prev = arrow('prev', '‹', 'Previous product');
    var next = arrow('next', '›', 'Next product');
    var nav = el('div', 'sp-slider__nav');
    wrap.appendChild(prev);
    wrap.appendChild(next);
    wrap.appendChild(nav);

    var index = 0;      // the leading (left-most) real card, 0..n-1 once settled
    var perView = 1;    // cards visible at once
    var step = 0;       // card width + gap
    var k = 0;          // clones on each side (= perView), so wrapping always has something to slide to
    var active = true;  // false when every card already fits: nothing to slide, so no clones, dots or arrows
    var clones = [];
    var dots = [];
    var landTimer = 0;

    function gap() {
      var cs = getComputedStyle(track);
      var g = parseFloat(cs.columnGap || cs.gap);
      return isNaN(g) ? 0 : g;
    }
    function measure() {
      var w = cards[0].getBoundingClientRect().width;
      step = w + gap();
      perView = step > 0 ? Math.max(1, Math.round((viewport.clientWidth + gap()) / step)) : 1;
    }
    function rebuildClones() {
      for (var c = 0; c < clones.length; c++) if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
      clones = [];
      k = Math.min(perView, n);
      for (var i = n - k; i < n; i++) clones.push(track.insertBefore(clone(cards[i]), cards[0]));
      for (var j = 0; j < k; j++) clones.push(track.appendChild(clone(cards[j])));
    }
    function clone(card) {
      var c = card.cloneNode(true);
      c.classList.add('sp-slider__clone');
      c.setAttribute('aria-hidden', 'true');
      if (c.tabIndex >= 0) c.tabIndex = -1;
      var focusable = c.querySelectorAll('a, button');
      for (var i = 0; i < focusable.length; i++) focusable[i].tabIndex = -1;
      return c;
    }
    function xFor(i) { return -(i + k) * step; }
    function currentX() {
      // Where the track is right now, even mid-glide.
      var t = getComputedStyle(track).transform;
      if (t && t !== 'none') {
        var nums = t.slice(t.indexOf('(') + 1).match(/-?[\d.]+(?:e-?\d+)?/g) || []; // skip the "3d" in matrix3d
        if (nums.length === 6) return parseFloat(nums[4]);
        if (nums.length === 16) return parseFloat(nums[12]);
      }
      var m = (track.style.transform || '').match(/\(\s*(-?[\d.]+)/);
      return m ? parseFloat(m[1]) : 0;
    }
    function place(x, animate) {
      if (!animate) track.style.transition = 'none';
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      if (!animate) { void track.offsetWidth; track.style.transition = ''; }
    }
    function real(i) { return ((i % n) + n) % n; }
    function land() {
      // A glide that ended on a clone jumps, invisibly, to the matching real card.
      clearTimeout(landTimer);
      if (index < 0 || index >= n) { index = real(index); place(xFor(index), false); }
      update();
    }
    function goTo(i) {
      clearTimeout(landTimer);
      index = i;
      var animate = !REDUCED && step > 0;
      place(xFor(index), animate);
      if (animate) landTimer = setTimeout(land, DURATION + 60); else land();
      update();
    }
    // Pages are groups of perView cards. Arrows and dots move page by page; a drag can stop on any card.
    // The last page is aligned to the end, so a count that does not divide evenly never shows a card twice.
    function pageStarts() {
      var s = [];
      for (var i = 0; i + perView < n; i += perView) s.push(i);
      s.push(Math.max(0, n - perView));
      return s;
    }
    function pages() { return pageStarts().length; }
    function pageOf(i) { // the page the leading card belongs to
      var cur = real(i), s = pageStarts(), p = 0;
      for (var j = 0; j < s.length; j++) if (s[j] <= cur) p = j;
      return p;
    }
    function goToPage(p, dir) {
      // dir: 1 forwards, -1 backwards, 0 whichever way is shorter. Wrapping slides through the clones.
      if (!active) return;
      var cur = real(index);
      var s = pageStarts();
      var target = s[((p % s.length) + s.length) % s.length];
      var options = [target - cur, target - cur - n, target - cur + n].filter(function (d) {
        if (dir > 0 && d <= 0) return false;
        if (dir < 0 && d >= 0) return false;
        return cur + d >= -k && cur + d <= n - 1 + k; // a path the clones can cover
      });
      if (!options.length) { goTo(target); return; }
      options.sort(function (a, b) { return Math.abs(a) - Math.abs(b); });
      goTo(cur + options[0]);
    }
    function nextPage() { // the first page that starts after the leading card, or round to the first
      var cur = real(index), s = pageStarts();
      for (var j = 0; j < s.length; j++) if (s[j] > cur) return goToPage(j, 1);
      goToPage(0, 1);
    }
    function prevPage() { // the last page that starts before the leading card, or round to the last
      var cur = real(index), s = pageStarts();
      for (var j = s.length - 1; j >= 0; j--) if (s[j] < cur) return goToPage(j, -1);
      goToPage(s.length - 1, -1);
    }
    function update() {
      var cur = pageOf(index);
      for (var i = 0; i < dots.length; i++) dots[i].setAttribute('aria-current', i === cur ? 'true' : 'false');
    }
    function buildDots() {
      var count = pages();
      if (dots.length === count) { update(); return; }
      nav.innerHTML = '';
      dots = [];
      for (var i = 0; i < count; i++) dots.push(dot(i, count));
      nav.hidden = count < 2;
      update();
    }
    function dot(i, count) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'sp-slider__dot';
      d.setAttribute('aria-label', 'Go to page ' + (i + 1) + ' of ' + count);
      d.addEventListener('click', function () { goToPage(i, 0); });
      nav.appendChild(d);
      return d;
    }

    track.addEventListener('transitionend', function (e) { if (e.target === track && e.propertyName === 'transform') land(); });
    prev.addEventListener('click', prevPage);
    next.addEventListener('click', nextPage);

    // Drag with a mouse, finger or pen, starting anywhere in the viewport (a card or the gap between two).
    // The row follows the pointer; on release it settles on the nearest card, or one further if it was a
    // quick flick. A real drag swallows the click after it.
    var drag = null;
    var swallowClick = false;
    viewport.addEventListener('dragstart', function (e) { e.preventDefault(); }); // no ghost image of the card
    viewport.addEventListener('pointerdown', function (e) {
      if (!active) return;
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      if (e.pointerType === 'mouse') e.preventDefault(); // no native image/link drag, no text selection
      clearTimeout(landTimer);
      var x = currentX();
      index = Math.round(-x / step) - k; // in case we grabbed it mid-glide
      drag = { id: e.pointerId, x0: e.clientX, startX: x, moved: false, lastX: e.clientX, lastT: Date.now(), vx: 0 };
      wrap.classList.add('is-dragging');
      place(x, false);
      // The pointer is captured only once a real drag starts (below): capturing it here would make the
      // browser deliver a plain click to the viewport instead of the card link.
    });
    // Moves and releases are watched on the document: a fast mouse can leave the viewport before the
    // drag threshold is crossed, and the drag must still follow it.
    document.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x0;
      if (!drag.moved && Math.abs(dx) > 5) {
        drag.moved = true;
        if (viewport.setPointerCapture) try { viewport.setPointerCapture(drag.id); } catch (err) { /* not needed */ }
      }
      if (!drag.moved) return;
      var now = Date.now();
      if (now > drag.lastT) drag.vx = (e.clientX - drag.lastX) / (now - drag.lastT);
      drag.lastX = e.clientX; drag.lastT = now;
      // When the row drifts past the cloned margin, shift it back by a whole cycle (an identical view),
      // so a long drag never hits a wall and there is always a card under the pointer.
      var x = drag.startX + dx;
      var cycle = n * step;
      var minX = xFor(n + k - perView);
      var maxX = xFor(-k);
      while (x < minX) { x += cycle; drag.startX += cycle; }
      while (x > maxX) { x -= cycle; drag.startX -= cycle; }
      track.style.transform = 'translate3d(' + x + 'px, 0, 0)';
      index = Math.round(-x / step) - k; // keep the dots live while dragging
      update();
    });
    function endDrag() {
      if (!drag) return;
      var d = drag;
      drag = null;
      if (viewport.releasePointerCapture) try { viewport.releasePointerCapture(d.id); } catch (err) { /* already released */ }
      wrap.classList.remove('is-dragging');
      track.style.transition = '';
      var x = currentX();
      var target = Math.round(-x / step) - k;
      if (d.moved) {
        swallowClick = true;
        setTimeout(function () { swallowClick = false; }, 0);
        var from = Math.round(-d.startX / step) - k;
        if (target === from && Math.abs(d.vx) > 0.4) target += d.vx < 0 ? 1 : -1; // a flick moves one card
        goTo(target);
      } else if (Math.abs(x - xFor(target)) > 0.5) {
        goTo(target); // grabbed mid-glide and let go: finish settling on a card instead of hanging between two
      }
    }
    document.addEventListener('pointerup', endDrag);
    document.addEventListener('pointercancel', endDrag);
    viewport.addEventListener('click', function (e) {
      if (swallowClick) { e.preventDefault(); e.stopPropagation(); }
    }, true);

    function layout() {
      measure();
      active = n > perView;
      wrap.classList.toggle('sp-slider--static', !active);
      prev.hidden = next.hidden = !active;
      if (!active) { // everything fits: show the cards as they are
        for (var c = 0; c < clones.length; c++) if (clones[c].parentNode) clones[c].parentNode.removeChild(clones[c]);
        clones = []; k = 0; index = 0;
        place(0, false);
        nav.innerHTML = ''; dots = []; nav.hidden = true;
        return;
      }
      rebuildClones();
      index = real(index);
      place(xFor(index), false);
      buildDots(); // the number of pages depends on how many cards fit
    }
    var resizeTimer = 0;
    function onResize() { clearTimeout(resizeTimer); resizeTimer = setTimeout(layout, 100); }
    if (window.ResizeObserver) new ResizeObserver(onResize).observe(viewport);
    else window.addEventListener('resize', onResize);

    layout();
  }

  function el(tag, className) {
    var e = document.createElement(tag);
    e.className = className;
    return e;
  }
  function arrow(kind, glyph, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sp-slider__arrow sp-slider__arrow--' + kind;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  /* Lightbox: in a gallery with the lightbox option, a picture without a link of its own opens full size
     over the page. The arrows, the arrow keys and a swipe move through that gallery; Esc, the close
     button or the dark backdrop close it. */
  function lightbox(gallery) {
    if (gallery.classList.contains('sp-gallery--js')) return; // already done
    gallery.classList.add('sp-gallery--js');
    var imgs = Array.prototype.slice.call(gallery.querySelectorAll('.sp-gallery__media > img'));
    if (!imgs.length) return;
    var box = null, pic = null, cap = null, count = null, current = 0, opener = null, swiped = false;

    function captionOf(img) {
      var fig = img.closest('figure');
      var c = fig && fig.querySelector('figcaption');
      return c ? c.textContent : '';
    }
    function show(i) {
      current = (i + imgs.length) % imgs.length;
      var img = imgs[current];
      pic.src = img.currentSrc || img.src;
      pic.alt = img.getAttribute('alt') || '';
      cap.textContent = captionOf(img);
      count.textContent = imgs.length > 1 ? (current + 1) + ' / ' + imgs.length : '';
    }
    function close() {
      if (!box) return;
      var b = box;
      box = null;
      document.removeEventListener('keydown', onKey);
      document.body.classList.remove('sp-lightbox-open');
      b.classList.remove('is-open');
      setTimeout(function () { if (b.parentNode) b.parentNode.removeChild(b); }, REDUCED ? 0 : 200);
      if (opener && opener.focus) opener.focus();
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') show(current - 1);
      else if (e.key === 'ArrowRight') show(current + 1);
      else return;
      e.preventDefault();
    }
    function open(i, from) {
      if (box) return;
      opener = from;
      box = el('div', 'sp-lightbox');
      box.setAttribute('role', 'dialog');
      box.setAttribute('aria-modal', 'true');
      box.setAttribute('aria-label', 'Image viewer');
      pic = el('img', 'sp-lightbox__img');
      cap = el('p', 'sp-lightbox__caption');
      count = el('span', 'sp-lightbox__count');
      var closeBtn = lightboxButton('close', '×', 'Close');
      var prev = lightboxButton('prev', '‹', 'Previous image');
      var next = lightboxButton('next', '›', 'Next image');
      prev.hidden = next.hidden = imgs.length < 2;
      box.appendChild(count);
      box.appendChild(closeBtn);
      box.appendChild(prev);
      box.appendChild(pic);
      box.appendChild(cap);
      box.appendChild(next);
      closeBtn.addEventListener('click', close);
      prev.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      next.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
      box.addEventListener('click', function (e) { if (!swiped && (e.target === box || e.target === cap)) close(); });
      var x0 = null;
      box.addEventListener('pointerdown', function (e) { x0 = e.clientX; });
      box.addEventListener('pointerup', function (e) {
        if (x0 == null) return;
        var dx = e.clientX - x0;
        x0 = null;
        if (Math.abs(dx) < 40 || imgs.length < 2) return;
        swiped = true; // the click that follows this swipe must not close the viewer
        setTimeout(function () { swiped = false; }, 0);
        show(dx < 0 ? current + 1 : current - 1);
      });
      document.body.appendChild(box);
      document.body.classList.add('sp-lightbox-open');
      document.addEventListener('keydown', onKey);
      show(i);
      requestAnimationFrame(function () { if (box) box.classList.add('is-open'); });
      closeBtn.focus();
    }
    for (var i = 0; i < imgs.length; i++) (function (img, idx) {
      img.setAttribute('tabindex', '0');
      img.setAttribute('role', 'button');
      img.addEventListener('click', function () { open(idx, img); });
      img.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(idx, img); } });
    })(imgs[i], i);
  }
  function lightboxButton(kind, glyph, label) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'sp-lightbox__btn sp-lightbox__' + kind;
    b.setAttribute('aria-label', label);
    b.textContent = glyph;
    return b;
  }

  function init(root) {
    var scope = root || document;
    var tracks = scope.querySelectorAll('.sp-products--slider');
    for (var i = 0; i < tracks.length; i++) enhance(tracks[i]);
    var galleries = scope.querySelectorAll('.sp-gallery--lightbox');
    for (var g = 0; g < galleries.length; g++) lightbox(galleries[g]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.Steeply = window.Steeply || {};
  window.Steeply.enhanceSliders = init;
})();
